import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckOutService } from '../../components/checkout/checkout.service';
import { CatalogueService } from '../../components/catalogue/catalogue.service';
import { ProductTemplateService } from '../../components/product-template/services/product-template.service';
import { SearchAllService } from '../../components/search-all/search-all.service';
import { OrderWithAiComponent } from './order-with-ai.component';
import { OrderWithAiService } from './order-with-ai.service';

@NgModule({
  declarations: [OrderWithAiComponent],
  imports: [CommonModule, FormsModule],
  exports: [OrderWithAiComponent],
  providers: [
    OrderWithAiService,
    SearchAllService,
    CheckOutService,
    CatalogueService,
    ProductTemplateService
  ]
})
export class OrderWithAiModule {}
